import { AutoAwesomeOutlined } from "@mui/icons-material";
import {
  Box,
  ButtonBase,
  Chip,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import { defaultLocale } from "../config";
import useChatbot from "../provider/chatbot_provider";

export default function SuggestionChips({
  gridSpace = 3,
  align,
  suggestions,
}: {
  gridSpace: number;
  align?: string;
  suggestions: string[];
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { addConversation } = useChatbot();
  return isSmallScreen ? (
    <Box
      px={align != "flex-end" ? 0:1}
      sx={{
        overflowY: "scroll",
        overflowX: "scroll",
        width: (theme) =>
          align != "flex-end" ? `calc(100svw - ${theme.spacing(5)})` : "100svw",
      }}
      display={"block"}
      flexDirection={"row"}
      whiteSpace={align != "flex-end" ? "wrap" : "nowrap"}
      // px={.5}
    >
      {suggestions.map((suggestion, index) => (
        <Box
          px={0.5}
          py={0.2}
          width={"100%"}
          display={"inline-block"}
          whiteSpace={"nowrap"}
        >
          <Chip
            label={suggestion}
            variant="outlined"
            onClick={() => addConversation(suggestion, defaultLocale)}
          />
        </Box>
      ))}
    </Box>
  ) : (
    <Grid container spacing={2} alignItems={align || "flex-start"}>
      {suggestions.map((suggestion, index) => (
        <Grid item md={gridSpace} key={index}>
          <motion.div
            initial={{ y: 100 }}
            transition={{ duration: 0.5 + index / 8 }}
            whileInView={{ y: 0 }}
            style={{ zIndex: -1 }}
          >
            <ButtonBase
              sx={{ borderRadius: 1, textAlign: "left" }}
              onClick={() => addConversation(suggestion, defaultLocale)}
            >
              <Box p={3} pl={1} pt={1} borderRadius={1} bgcolor={"white"}>
                <Box>
                  <IconButton>
                    <AutoAwesomeOutlined />
                  </IconButton>
                </Box>
                <Box px={2}>
                  <Typography variant="body2">{suggestion}</Typography>
                </Box>
              </Box>
            </ButtonBase>
          </motion.div>
        </Grid>
      ))}
    </Grid>
  );
}
